import { Injectable } from '@angular/core';
import { DynamicScriptService } from './dynamic-script.service';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  constructor(private dynamicScript: DynamicScriptService) {}

  init(): void {
    const id = environment.googleAnalytics;
    if (!id) return;

    this.dynamicScript.loadDynamicScript(
      'google-tag-manager',
      `https://www.googletagmanager.com/gtm.js?id=${id}`,
      { attrs: { async: 'true' } }
    ).catch((error) => console.log(error));

    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
    `;

    document.head.insertBefore(inlineScript, document.head.firstChild);

    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${id}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.cssText = 'display:none;visibility:hidden';
    noscript.appendChild(iframe);

    document.body.appendChild(noscript);
  }
}
